import React from 'react'
import config from 'config'

import RichCta from 'components/rich-cta'
import WidgetPage from 'components/hocs/widget-page'

export const RichCtaApp = (props) => (
  <RichCta
    nmls
    url={`${config.credibleRoot}/mortgage-refinance`}
    title="Refinance your mortgage and start saving now."
    body="Compare pre-qualified rates from multiple lenders in minutes."
    ctaText="Get Started"
    {...props}
  />
)

export default WidgetPage(RichCtaApp)
